module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA0UlEQVR4Ac1RA1ZGYRBtBbWHp3mjbJsLCEdpBWEDYSO5DrKt7yC3on4z+zNG996MX2mnoO8czzucg24BbwKfv+lwFrK+cXW0mIdLOHAIXM9ecgh87IMceGJsqa6nynoyTvAaeDx71uESdAmotJmphagRqQm5hUqaeRHo8qWSjKfzLNKEfSU4WILciPMixnsZwwnoo609FZTZgVkd2FVJD/aroAMQdz3x23m8gCfzGdp5B+T8dYcVn6eJrl0NjGnkwPUlh7iP8eKQUqT4rNL/rD0ByD+dIF2XU+cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MA.png
// module id = 1200
// module chunks = 0